module.exports = __webpack_public_path__ + "img/corporate-culture.3358acbd.png";